import { User } from "./../user.model";
import { AuthService } from "./../auth.service";
import { Observable } from "rxjs";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-main-toolbar",
  templateUrl: "./main-toolbar.component.html",
  styleUrls: ["./main-toolbar.component.css"]
})
export class MainToolbarComponent implements OnInit {
  constructor(private authService: AuthService) {}

  user$: Observable<User>;

  ngOnInit() {
    this.user$ = this.authService.user$;
  }
}
